module.exports = __webpack_public_path__ + "img/bg1.fd2364de.jpg";